export default __webpack_public_path__ + "static/media/plus_black.7b3d42fe.svg";